import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/heading1.png'
import _imports_1 from '@/assets/heading2.jpg'
import _imports_2 from '@/assets/heading3.png'
import _imports_3 from '@/assets/heading4.png'


const _hoisted_1 = { class: "hero-landing container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "hero-landing__title color-primary" }, "Front-end / iOS developer", -1)
const _hoisted_3 = { class: "hero-landing__center-block" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "color-secondary uppercase bold" }, "Lennart Hakker", -1)
const _hoisted_5 = {
  key: 0,
  alt: "Lennart Hakker",
  src: _imports_0
}
const _hoisted_6 = {
  key: 1,
  alt: "Lennart Hakker",
  src: _imports_1
}
const _hoisted_7 = {
  key: 2,
  alt: "Lennart Hakker",
  src: _imports_2
}
const _hoisted_8 = {
  key: 3,
  alt: "Lennart Hakker",
  src: _imports_3
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  class: "hero-landing__email color-primary none-xs",
  href: "mailto:info@lennarthakker.com"
}, " info@lennarthakker.com ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_icon = _resolveComponent("dots-icon")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_dots_icon, { class: "absolute top-percentage-10 left-percentage-5" }),
    _createVNode(_component_dots_icon, { class: "absolute top-percentage-10 right-percentage-5" }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_ctx.currentImage === 0)
        ? (_openBlock(), _createElementBlock("img", _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.currentImage === 1)
        ? (_openBlock(), _createElementBlock("img", _hoisted_6))
        : _createCommentVNode("", true),
      (_ctx.currentImage === 2)
        ? (_openBlock(), _createElementBlock("img", _hoisted_7))
        : _createCommentVNode("", true),
      (_ctx.currentImage === 3)
        ? (_openBlock(), _createElementBlock("img", _hoisted_8))
        : _createCommentVNode("", true)
    ]),
    _hoisted_9
  ]))
}